import { PagerObject } from "../../types/DataFetchingTypes";
import { DocumentReview, ExpandedDocumentReview } from "../../types/ReviewTypes";
import { SortFilterPaged } from "../CommonInterfaces";
import { safeDELETE, safeGET, safePUT } from "./SafeClient";

export function listReviews(
    pager: SortFilterPaged<ExpandedDocumentReview>,
    vendorKeys?: string[],
    abort?: any
): Promise<PagerObject<ExpandedDocumentReview[]>> {
    const sorting = pager.sort
        .map((v) => `sort[]=${v.attribute}&order[]=${v.order}`)
        .reduce((p, v) => `${p}&${v}`, "");
    const paging = `current=${pager.pager.pagination.current}&pageSize=${pager.pager.pagination.pageSize}`;
    const filtering = pager.filter
        .map((v) => {
            return v.filter
                .map((fv) => {
                    return `filter[]=${fv.attribute}&operand[]=${fv.operand}&value[]=${fv.value}&group[]=${v.groupId}&gop[]=${v.groupType}`;
                })
                .join("&");
        })
        .reduce((p, v) => `${p}&${v}`, "");
    let vendorQuery = "";
    if (vendorKeys?.length) {
        vendorQuery = vendorKeys
            .map((v) => `vendorKey[]=${encodeURIComponent(v)}`)
            .reduce((p, v) => `${p}&${v}`, "");
    }
    return safeGET(`/api/review?${paging}${sorting}${filtering}${vendorQuery}`, abort);
}

export function deleteReview(documentSerialId: string, abort?: any): Promise<boolean> {
    return safeDELETE(`/api/review/${documentSerialId}`, {}, abort);
}

export function editReview(review: DocumentReview, abort?: any): Promise<boolean> {
    return safePUT(`/api/review/${review.documentSerialId}/update`, review, abort);
}

export function getDocumentCount(abort?: any): Promise<{ total: number }> {
    return safeGET(`/api/review/document/count`, abort);
}
